import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f335073a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f335073a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f335073a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f335073a')) {
      api.createRecord('f335073a', component.options)
    } else {
      api.reload('f335073a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f335073a&scoped=true", function () {
      api.rerender('f335073a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/alliance/verify/index.vue"
export default component.exports